import _ from 'lodash';
import { createClient } from '@/shared/api';
import STUDY_PATIENT_INFO_QUERY from '@/entities/study/api/queries/studyPatientInfo';
import type { OnBoarding } from '@/entities/study/api/fragments/onBoardingFragment';
import type { Patient, Diagnosis, Insurance } from '@/shared/api';

type PhysicianContact = { phone1: string; nightPhone: string; fax: string };
type Physician = {
  id: string;
  firstName: string;
  lastName: string;
  contact: PhysicianContact;
  email: string;
};

export type StudyPatientInfo = {
  id: string;
  onboarding: OnBoarding;
  info: {
    patient: Patient;
    diagnosis: Diagnosis;
    insurance: Insurance;
    interprettingPhysician: Physician;
    referringPhysician: Physician;
  };
  device: { id: string; deviceId: string; model: string };
  isAFibDetected: boolean;
  hasAFibCode: boolean;
};

/**
 * Loads the patient information attached to a study. Runs the patient info query, throws the first GraphQL error when no study came back, and hands back the whole Apollo result rather than the study alone.
 *
 * @param id - Identifier of the study.
 * @returns A promise resolving to the full Apollo query result.
 */
const fetchStudyPatientInfo = async (id: string) => {
  const client = await createClient();
  const result = await client.query<{ study: StudyPatientInfo }>({
    query: STUDY_PATIENT_INFO_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = result;
  const { study } = data;
  if (_.isNil(study) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return result;
};

export default fetchStudyPatientInfo;
